// Module
var code = "<!DOCTYPE html> <div class=\"centered\" role=\"img\" title=\"QuadPay Loading Screen\"> </div>";
// Exports
export default code;